import { render } from "./ReportsPageTableColumnStatusDownload.vue?vue&type=template&id=a3994fa2&ts=true"
import script from "./ReportsPageTableColumnStatusDownload.vue?vue&type=script&lang=ts"
export * from "./ReportsPageTableColumnStatusDownload.vue?vue&type=script&lang=ts"

import "./ReportsPageTableColumnStatusDownload.vue?vue&type=style&index=0&id=a3994fa2&lang=stylus"

import exportComponent from "/tmp/ffsecurity-ui/packages/v2/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__